/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.32/esri/copyright.txt for details.
*/
function e(e){return r(e?.visualVariables[0])}function r(e){return[e?.minSliderValue??0,e?.maxSliderValue??0]}export{e as authoringInfoFirstVariableSliderMinMax,r as authoringInfoVariableSliderMinMax};
